import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { alpha, useTheme } from '@mui/material/styles';
import MenuIcon from '@mui/icons-material/Menu';
import LogoIcon from '../../../../images/icons/logo_icon.svg';
import { Link } from 'react-router-dom';

const Topbar = ({
  onSidebarOpen,
}: { onSidebarOpen: any } | { pages: any } | any) => {
  const theme = useTheme();

  return (
    <Box
      sx={{ display: { xs: 'flex', md: 'none' } }}
      /* justifyContent={'space-between'} */
      alignItems={'center'}
      width={1}
    >
      <Box
        sx={{ display: { xs: 'block', md: 'none' }, paddingRight: 2 }}
        alignItems={'center'}
      >
        <Button
          onClick={() => onSidebarOpen()}
          aria-label="Menu"
          variant={'outlined'}
          sx={{
            borderRadius: 2,
            minWidth: 'auto',
            padding: 1,
            borderColor: alpha(theme.palette.divider, 0.2),
          }}
        >
          <MenuIcon />
        </Button>
      </Box>
      <Box
        alignItems={'center'}
        display={'flex'}
        justifyContent={'space-between'}
        flexGrow={'1'}
      >
        <Box
          display={'flex'}
          component="a"
          href="/"
          title="Hauscanner"
          width={{ xs: 100, md: 120 }}
        >
          <Box component={'img'} src={LogoIcon} height={1} width={0.33} />
        </Box>
        <Button
          size={'small'}
          variant="contained"
          color="primary"
          component={Link}
          to="/properties"
        >
          Busca tu propiedad
        </Button>
      </Box>
    </Box>
  );
};

export default Topbar;
